module.exports = __webpack_public_path__ + "static/premium-icon-e8eb2470442c6dca0e85c4496616145e.svg";